module.exports = __webpack_public_path__ + "img/electric-gear.d8e0f573.svg";